module.exports = __webpack_public_path__ + "assets/img/img_2_9_2.46dbb600.png";